/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-props-no-spreading */
import queryString from "query-string";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Button as MuiButton } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { Helmet } from "react-helmet";
import EmptyFileIcon from "../../../../assets/svg/EmptyFile";
import ReloadIcon from "../../../../assets/svg/ReloadIcon";
import AppliedFilter from "../../../../components/common/AppliedFilter/AppliedFilter";
import Loader from "../../../../components/common/Loader/Loader";
import Modal from "../../../../components/common/Modal/Modal";
import {
  AppliedFilterLabelMap,
  DATES,
  EVENT_NAME,
  Constants,
  AlertStatus,
} from "../../../../contants";
import useParamsQuery from "../../../../hooks/useParamsQuery";
import { selectOSKeysByUserRole } from "../../../../redux/selectors/user";
import Reports from "../../../../services/api/reports";
import { formDataToObject, isEmptyObj } from "../../../../utils/helper";
import styles from "../FriendSearch.styles";
import ReportTable from "./Components/FriendToMemberGrowthTable";
import OrganizationSearch from "../../SubscriptionReports/OrganizationSearchReports";
import AdvanceSearch from "../../SubscriptionReports/Components/AdvanceSearchSubscriptionTrends";
import {
  getFilters,
  getFormattedQuery,
  getRoutePathforFriendToMemberGrowth,
  handleDependencyFilter,
} from "../FriendToMemberTrend/utils";
import { ToastAlertContext } from "../../../../config/providers/ToastAlert";
import Toast from "../../../../components/common/Toast";

const LOADER_DELAY = 1000;
const PAGE = "page";

const filterOrder = [
  "areaId",
  "zoneId",
  "regionId",
  "chapterId",
  "districtId",
  // OLD:
  // "blockId",
];

function FriendToMemberGrowth() {
  const TITLE = "Friend to Member Growth Report - BSG";
  const [searchData, setSearchData] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openResultModal, setOpenResultModal] = useState(false);
  const [showSearchResult, setShowSearchResult] = useState(false);
  const [tableSearch, setTableSearch] = useState("");
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );

  const formRef = useRef(null);
  const hasAutoLoadedRef = useRef(false);
  const autoLoadTimerRef = useRef(null);
  const suppressUrlEffectFetchRef = useRef(false);
  const disableAutoLoadRef = useRef(false);

  const navigate = useNavigate();
  const disabledOSKeys = useSelector(selectOSKeysByUserRole);
  const metaData = useSelector((state) => state.meta);
  const { getQueryObject, getQueryParams, urlSearchParams } = useParamsQuery();
  const toast = useContext(ToastAlertContext);
  const [showToast, setShowToast] = useState(null);

  useEffect(() => {
    const onResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    return () => {
      if (autoLoadTimerRef.current) {
        clearTimeout(autoLoadTimerRef.current);
      }
    };
  }, []);

  const getErrorMessage = (error) => {
    if (!error) return "Something went wrong. Please contact support.";
    if (typeof error === "string") return error;
    if (typeof error?.message === "string") return error.message;
    if (typeof error?.response?.data?.message === "string") {
      return error.response.data.message;
    }
    return "Something went wrong. Please contact support.";
  };

  const clearFormRef = () => {
    Object.keys(AppliedFilterLabelMap).forEach((key) => {
      if (formRef.current?.[key]) {
        formRef.current[key].value = "";
        formRef.current[key]?.blur();
      }
    });
  };

  const resetLocalState = () => {
    setSearchData([]);
    setAppliedFilters([]);
    setTableSearch("");
    setOpenResultModal(false);
    setShowSearchResult(false);
    setIsLoading(false);
  };

  const initializeFormState = (queryObject) => {
    if (!isEmptyObj(queryObject) && formRef.current) {
      Object.keys(queryObject).forEach((key) => {
        if (formRef.current?.[key]) {
          formRef.current[key].value = queryObject[key];
        }
      });
    }
  };

  const updateSearchParam = (query) => {
    if (query?.length) {
      navigate(`${getRoutePathforFriendToMemberGrowth()}?${query}`);
    } else {
      navigate(`${getRoutePathforFriendToMemberGrowth()}`);
    }
  };

  const removeKeyFromQuery = (queryObject, filterKey) => {
    let updatedQuery = {
      ...queryObject,
    };

    if (DATES.includes(filterKey)) {
      delete updatedQuery[filterKey];
      delete updatedQuery[`${filterKey.split("From")[0]}To`];
    } else {
      delete updatedQuery[filterKey];
    }

    if (Object.keys(updatedQuery).length === 1 && PAGE in updatedQuery) {
      delete updatedQuery[PAGE];
    }

    updatedQuery = handleDependencyFilter(updatedQuery, disabledOSKeys);
    return updatedQuery;
  };

  const hasAnyRealFilter = (q) => {
    if (!q || isEmptyObj(q)) return false;
    return Object.entries(q).some(
      ([k, v]) =>
        !["pageNumber", "pageSize"].includes(k) &&
        v !== undefined &&
        String(v).trim() !== ""
    );
  };

  const getFormValuesFromRef = () => {
    if (!formRef.current) return {};
    const rawFormData = new FormData(formRef.current);
    const formData = formDataToObject(rawFormData);

    return Object.fromEntries(
      Object.entries(formData || {}).filter(
        ([, val]) =>
          val !== undefined && val !== null && String(val).trim() !== ""
      )
    );
  };

  const getCurrentBaseQuery = () => {
    const queryObject = getQueryObject();
    if (!isEmptyObj(queryObject) && hasAnyRealFilter(queryObject)) {
      return queryObject;
    }
    return getFormValuesFromRef();
  };

  const validateAndFetchData = (formattedQuery) => {
    if (
      !formattedQuery.hasOwnProperty("areaId") ||
      formattedQuery.areaId === ""
    ) {
      setIsLoading(false);
      return false;
    }
    return true;
  };

  const fetchSearchData = async (queryParams, options = {}) => {
    const { openModal = true } = options;

    try {
      setIsLoading(true);

      const formattedQuery = getFormattedQuery({
        ...queryParams,
      });

      if (!validateAndFetchData(formattedQuery)) {
        return;
      }

      const response = await Reports.FriendToMemberGrowthReport(formattedQuery);
      const data = Array.isArray(response?.data) ? response.data : [];

      setSearchData(data);

      setTimeout(() => {
        setIsLoading(false);

        if (data.length > 0) {
          if (openModal) {
            setOpenResultModal(true);
            setShowSearchResult(true);
          }
        } else {
          setOpenResultModal(false);
          setShowSearchResult(false);
          setShowToast({
            severity: "error",
            message: "No data found",
          });
        }
      }, LOADER_DELAY);
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setIsLoading(false);
      setOpenResultModal(false);
      setShowSearchResult(false);
      setShowToast({
        severity: "error",
        message: errorMessage,
      });
      toast.show(errorMessage, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();

    const formData = getFormValuesFromRef();
    const hasFilter = Object.keys(formData).length > 0;

    if (!hasFilter) {
      setShowToast({
        severity: "warning",
        message: "Please select your search filter",
      });
      return;
    }

    disableAutoLoadRef.current = false;
    hasAutoLoadedRef.current = true;
    document.dispatchEvent(new Event(EVENT_NAME));

    const query = queryString.stringify(formData);
    updateSearchParam(query);
  };

  useEffect(() => {
    const queryObject = getQueryObject();

    if (isEmptyObj(queryObject)) {
      resetLocalState();
      return;
    }

    if (!hasAnyRealFilter(queryObject)) {
      resetLocalState();

      if (
        queryObject.pageNumber !== undefined ||
        queryObject.pageSize !== undefined
      ) {
        updateSearchParam();
      }
      return;
    }

    initializeFormState(queryObject);

    if (suppressUrlEffectFetchRef.current) {
      suppressUrlEffectFetchRef.current = false;
      return;
    }

    hasAutoLoadedRef.current = true;
    fetchSearchData(queryObject, { openModal: true });
  }, [urlSearchParams.toString()]);

  useEffect(() => {
    const queryObject = getQueryObject();

    if (!isEmptyObj(queryObject)) return;
    if (hasAutoLoadedRef.current) return;
    if (disableAutoLoadRef.current) return;

    let attempts = 0;
    const maxAttempts = 20;

    const tryAutoLoad = () => {
      attempts += 1;
      const formValues = getFormValuesFromRef();

      if (formValues?.areaId) {
        hasAutoLoadedRef.current = true;

        const query = queryString.stringify(formValues);

        // first fetch manually
        fetchSearchData(formValues, { openModal: true });

        // then sync URL without duplicate fetch
        suppressUrlEffectFetchRef.current = true;
        updateSearchParam(query);
        return;
      }

      if (attempts < maxAttempts) {
        autoLoadTimerRef.current = setTimeout(tryAutoLoad, 300);
      }
    };

    autoLoadTimerRef.current = setTimeout(tryAutoLoad, 300);

    return () => {
      if (autoLoadTimerRef.current) {
        clearTimeout(autoLoadTimerRef.current);
      }
    };
  }, [disabledOSKeys, metaData]);

  useEffect(() => {
    const currentBaseQuery = getCurrentBaseQuery();

    if (!isEmptyObj(currentBaseQuery) && metaData && disabledOSKeys) {
      try {
        setAppliedFilters(
          getFilters(currentBaseQuery, metaData, disabledOSKeys)
        );
      } catch (err) {
        setAppliedFilters([]);
      }
    } else {
      setAppliedFilters([]);
    }
  }, [metaData, disabledOSKeys, urlSearchParams.toString(), openResultModal]);

  const onRemoveFilter = (filterKey) => {
    const currentBaseQuery = getCurrentBaseQuery();

    if (isEmptyObj(currentBaseQuery)) return;

    const updatedObject = removeKeyFromQuery(currentBaseQuery, filterKey);
    const updatedQuery = queryString.stringify(updatedObject);

    disableAutoLoadRef.current = false;
    hasAutoLoadedRef.current = true;
    updateSearchParam(updatedQuery);
  };

  const onRefresh = () => {
    const currentBaseQuery = getCurrentBaseQuery();
    if (hasAnyRealFilter(currentBaseQuery)) {
      fetchSearchData(currentBaseQuery, { openModal: true });
    }
  };

  const fetchChildren = async (queryParams) => {
    try {
      const formattedQuery = getFormattedQuery({
        ...queryParams,
      });

      const response = await Reports.FriendToMemberGrowthReport(formattedQuery);
      // OLD: assumed API returns array directly
      // return Array.isArray(response?.data) ? response.data : [];

      // NEW: supports both response shapes
      // 1) CommonResponse: { code, message, data: [...] }
      // 2) Direct array: [...]
      const wrapper = response?.data;
      const data = wrapper?.data ?? wrapper;
      return Array.isArray(data) ? data : [];
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setShowToast({
        severity: "error",
        message: errorMessage,
      });
      Sentry.captureException(error);
      return [];
    }
  };

  const handleGoBackToSearch = () => {
    setOpenResultModal(false);
    setShowSearchResult(false);
  };

  const handleResetAndClose = () => {
    disableAutoLoadRef.current = true;
    hasAutoLoadedRef.current = true;

    if (autoLoadTimerRef.current) {
      clearTimeout(autoLoadTimerRef.current);
    }

    resetLocalState();
    clearFormRef();
    updateSearchParam();
  };

  const orderedFilters = filterOrder
    .map((filterKey) =>
      appliedFilters.find((filter) => filter.key === filterKey)
    )
    .filter(Boolean);

  const additionalFilters = appliedFilters.filter(
    (filter) => !filterOrder.includes(filter.key)
  );

  const filteredSearchData = useMemo(() => {
    if (!tableSearch || !String(tableSearch).trim()) return searchData;
    const q = String(tableSearch).trim().toLowerCase();

    return (searchData || []).filter((r) =>
      String(r?.structureName || "")
        .toLowerCase()
        .includes(q)
    );
  }, [searchData, tableSearch]);

  const summaryMeta = useMemo(() => {
    const rows = filteredSearchData || [];
    const first = rows.length ? rows[0] : null;
    const hierarchy = first?.hierarchy;

    const levelLabelMap = {
      ZONE: "Zone",
      REGION: "Region",
      CHAPTER: "Chapter",
      DISTRICT: "District",
      // OLD:
      // BLOCK: "Block",
    };

    const totalLevelCount = new Set(
      rows.map((r) => `${r?.hierarchy}-${r?.structureId}`)
    ).size;

    const totalMembers = rows.reduce((sum, r) => {
      return (
        sum +
        (r?.mdcount || 0) +
        (r?.wdcount || 0) +
        (r?.ymdcount || 0) +
        (r?.ywdcount || 0) +
        (r?.fdbcount || 0) +
        (r?.fdgcount || 0)
      );
    }, 0);

    const targetMembers = rows.reduce(
      (sum, r) => sum + (r?.targetCount || 0),
      0
    );

    return {
      hierarchy,
      levelLabel: levelLabelMap[hierarchy] || "Structure",
      totalLevelCount,
      totalMembers,
      targetMembers,
    };
  }, [filteredSearchData]);

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>

      <div style={styles.container}>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "1px",
          }}
        >
          <MuiButton
            onClick={handleResetAndClose}
            variant="outlined"
            color="secondary"
            sx={{
              textTransform: "none",
              height: "20px",
              fontSize: "13px",
              fontWeight: "600",
              marginRight: "10px",
              width: "85px",
              padding: "0px !important",
            }}
          >
            Clear Filters
          </MuiButton>
        </div>

        <div style={styles.filter}>
          <form
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              width: "100%",
            }}
            onSubmit={onSubmit}
            ref={formRef}
          >
            <div>
              <div style={{ fontWeight: "600", marginBottom: "8px" }}>
                Organization Structure
              </div>
              <OrganizationSearch
                formRef={formRef}
                disabledOSKeys={disabledOSKeys}
                showBlock={false}
              />
            </div>

            <div>
              <div style={{ width: isMobile ? "95%" : "85%" }}>
                <AdvanceSearch
                  formRef={formRef}
                  disabledOSKeys={disabledOSKeys}
                  hideDateFilters
                />
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: isMobile ? "center" : "flex-end",
                paddingTop: isMobile ? "20px" : "10px",
                marginRight: isMobile ? "15px" : "10px",
                paddingBottom: isMobile ? "100px" : "0px",
              }}
            >
              <MuiButton
                type="submit"
                variant="contained"
                color="primary"
                sx={{
                  width: isMobile ? "90%" : "auto",
                }}
              >
                Search
              </MuiButton>
            </div>
          </form>
        </div>

        {isMobile && (
          <div
            style={{
              borderTop: "2px solid #ffffffff",
              paddingTop: "15px",
              paddingBottom: "30px",
              marginTop: "10px",
            }}
          />
        )}

        {isLoading && <Loader />}

        <Modal
          open={openResultModal}
          onClose={handleGoBackToSearch}
          title="Search Results"
          customStyle={{
            marginTop: "30px",
            width: "98%",
            maxWidth: "100%",
            height: "90%",
            maxHeight: "100%",
            overflowY: "auto",
            backgroundColor: "#fff",
            display: "flex",
            flexDirection: "column",
            padding: "0px 10px 2px 10px",
            position: "relative",
          }}
        >
          {isLoading ? (
            <Loader />
          ) : searchData.length > 0 ? (
            <>
              <div style={{ marginTop: "10px", marginBottom: "10px" }}>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    alignItems: "stretch",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      flex: "1 1 220px",
                      minWidth: 220,
                      borderRadius: 12,
                      padding: "12px 14px",
                      background:
                        "linear-gradient(135deg, #3b82f6 0%, #06b6d4 100%)",
                      color: "#fff",
                      boxShadow: "0 6px 18px rgba(15, 23, 42, 0.10)",
                    }}
                  >
                    <div style={{ fontSize: 12, opacity: 0.95 }}>
                      {`Total ${summaryMeta.levelLabel}s`}
                    </div>
                    <div style={{ fontSize: 22, fontWeight: 800 }}>
                      {summaryMeta.totalLevelCount}
                    </div>
                  </div>

                  <div
                    style={{
                      flex: "1 1 220px",
                      minWidth: 220,
                      borderRadius: 12,
                      padding: "12px 14px",
                      background:
                        "linear-gradient(135deg, #10b981 0%, #22c55e 100%)",
                      color: "#fff",
                      boxShadow: "0 6px 18px rgba(15, 23, 42, 0.10)",
                    }}
                  >
                    <div style={{ fontSize: 12, opacity: 0.95 }}>
                      Total Members
                    </div>
                    <div style={{ fontSize: 22, fontWeight: 800 }}>
                      {summaryMeta.totalMembers}
                    </div>
                  </div>

                  <div
                    style={{
                      flex: "1 1 220px",
                      minWidth: 220,
                      borderRadius: 12,
                      padding: "12px 14px",
                      background:
                        "linear-gradient(135deg, #8b5cf6 0%, #6366f1 100%)",
                      color: "#fff",
                      boxShadow: "0 6px 18px rgba(15, 23, 42, 0.10)",
                    }}
                  >
                    <div style={{ fontSize: 12, opacity: 0.95 }}>
                      Target Members
                    </div>
                    <div style={{ fontSize: 22, fontWeight: 800 }}>
                      {summaryMeta.targetMembers}
                    </div>
                  </div>

                  <div
                    style={{
                      flex: "2 1 320px",
                      minWidth: 260,
                      borderRadius: 12,
                      padding: "10px 12px",
                      border: "1px solid #e5e7eb",
                      backgroundColor: "#fff",
                      boxShadow: "0 6px 18px rgba(15, 23, 42, 0.06)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 10,
                    }}
                  >
                    <div style={{ fontSize: 12, fontWeight: 700 }}>
                      Search {`${summaryMeta.levelLabel}s`}
                    </div>
                    <input
                      value={tableSearch}
                      onChange={(e) => setTableSearch(e.target.value)}
                      placeholder={`Search ${summaryMeta.levelLabel}s...`}
                      style={{
                        flex: 1,
                        height: 34,
                        borderRadius: 10,
                        border: "1px solid #e5e7eb",
                        padding: "0 12px",
                        outline: "none",
                        fontSize: 13,
                      }}
                    />
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: "10px",
                  fontWeight: 600,
                  fontSize: 13,
                  marginBottom: "0px",
                  paddingBottom: "0px",
                  borderBottom: "1px solid #eee",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    gap: 10,
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  {appliedFilters.length > 0 && (
                    <div style={{ flex: 1, minWidth: 200 }}>
                      <div style={styles.filterWrapper}>
                        <div style={styles.filterContainer}>
                          {orderedFilters.map((filter) => (
                            <AppliedFilter
                              key={filter.key}
                              filter={filter}
                              onRemove={onRemoveFilter}
                            />
                          ))}
                          {additionalFilters.map((filter) => (
                            <AppliedFilter
                              key={filter.key}
                              filter={filter}
                              onRemove={onRemoveFilter}
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    flexWrap: "wrap",
                    flex: "0 0 auto",
                  }}
                >
                  <div style={styles.reload} onClick={onRefresh}>
                    <ReloadIcon />
                  </div>
                  <MuiButton
                    onClick={handleResetAndClose}
                    variant="outlined"
                    color="secondary"
                    sx={{
                      textTransform: "none",
                      height: "32px",
                      fontSize: "13px",
                      padding: "0 14px",
                      minWidth: "100px",
                    }}
                  >
                    Clear Filters
                  </MuiButton>
                  <MuiButton
                    onClick={handleGoBackToSearch}
                    variant="contained"
                    color="primary"
                    sx={{
                      textTransform: "none",
                      height: "32px",
                      fontSize: "13px",
                      padding: "0 14px",
                    }}
                  >
                    Back
                  </MuiButton>
                </div>
              </div>

              <div style={{ flex: 1, overflowX: "auto", marginTop: "10px" }}>
                <ReportTable
                  rows={filteredSearchData}
                  baseQuery={getCurrentBaseQuery()}
                  fetchChildren={fetchChildren}
                />
              </div>
            </>
          ) : showSearchResult ? null : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: "15px 0",
                color: "#777",
              }}
            >
              <EmptyFileIcon width={100} />
              <span>No data found with current Filters</span>
            </div>
          )}
        </Modal>

        <Toast
          open={!!showToast}
          severity={showToast?.severity || ""}
          message={showToast?.message || ""}
          handleClose={() => setShowToast(null)}
        />
      </div>
    </>
  );
}

export default FriendToMemberGrowth;
